ApiError = require 'network/api-error'
Auth = require 'db/auth'
Backbone = require 'backbone'
Batcher = require './batcher'
ClientVersion = require 'debug/client-version'
Controller = require 'controller'
Monitor = require 'lib/monitor'
Promise = require 'bluebird'
_ = require 'underscore'
log = require 'debug/log'
f = require 'effing'

makeErrorEnum = require 'lib/make-error-enum'

RpcError = makeErrorEnum 'RPC', [
  'SyncError'
  'BatchError'
]

tryParseJSON = (str) ->
  try
    JSON.parse(str)
  catch
    null

# Here we use polling instead of any socket or Comet-style interaction, so we have to fake out
# anything that relies on server push (e.g. subscription).
module.exports = class AJAXRPC
  _.extend @prototype, Backbone.Events

  constructor: (@delegate) ->
    @idBoardToPoll = null
    @modelIxUpdate = {}
    @msPoll = 2000
    @msPollIdle = 10000
    @ajaxSessionId = Math.random().toString().substring(2)
    while @ajaxSessionId.length < 16
      @ajaxSessionId += '0'

    @consecutiveFailures = 0
    @consecutiveFailuresAllowed = 300

    @totalFailures = 0
    @totalFailuresAllowed = 1000

  subscribe: (modelType, idModel, tags, next) ->
    next?()

  unsubscribe: (modelType, idModel, next) ->
    next?()

  # There's no resync logic over AJAX; just wait til the next poll
  resync: ->

  _getPollLength: ->
    if Auth.isLoggedIn() && Monitor.getStatus() == 'active'
      @msPoll
    else
      @msPollIdle

  stopPolling: ->
    if @_pollingTimeout?
      clearTimeout(@_pollingTimeout)
      delete @_pollingTimeout

  poll: ->
    @_pollingTimeout = setTimeout =>
      if @consecutiveFailures >= @consecutiveFailuresAllowed ||
          @totalFailures >= @totalFailuresAllowed
        @trigger('connect_failed')
        return

      @doPoll (err) =>
        if err?
          if err == 'syncError'
            # Stop polling; we're currently requesting a refresh
            return
          @trigger('connecting')
          ++@consecutiveFailures
          ++@totalFailures
        else
          if @consecutiveFailures > 0
            @trigger('reconnect')
          @consecutiveFailures = 0

        if @_pollingTimeout?
          @poll()

    , @_getPollLength()

  # SocketRPC uses doPoll to sync up after it loses its connection, and thus
  # needs to override the models to poll for and be the Backbone event emitter
  # for the response messages. It would be nice to restructure this.
  doPoll: ([idModels, messageHandler]..., next) ->
    subscriptions = []
    messageHandler ?= @
    if _.isArray(idModels)
      for idModel in idModels
        subscriptions.push @delegate.currentSubscriptions[idModel]
    else if !idModels?
      for idModel, subscription of @delegate.currentSubscriptions
        subscriptions.push subscription
    else
      log('rpc', "Bad argument to doPoll: #{ idModels }")
      return

    if !_.isEmpty(subscriptions)
      @_doPoll(subscriptions, messageHandler, next)
    else
      log('rpc', "No models to poll for #{idModels}")
      next?()

  _doPoll: (subscriptions, messageHandler, next) ->
    batcher = new Batcher()

    batchRequests = subscriptions.map ({ modelType, idModel, ixLastUpdate, tags }) =>
      url = "/#{ modelType }/#{ idModel }/deltas" +
            "?ixLastUpdate=" + encodeURIComponent(ixLastUpdate.toString()) +
            "&tags=" + encodeURIComponent(tags.join(','))
      batcher.request(url)
      .tap (res) =>
        if res.syncError?
          return Promise.reject RpcError.SyncError(res.syncError)

        @delegate.setIxLastUpdate(idModel, res.modelIxUpdate[idModel])

        _.chain(res.messages ? [])
        .map(tryParseJSON)
        .compact()
        .forEach ({ notify, idModelChannel }) =>
          messageHandler.trigger notify.event,
            _.extend({ idModelChannel }, notify)
          return

        @dateLastMessage = Date.now()
        return
      .catch ApiError, ->
        # Unlike a SyncError, an ApiError here isn't sufficient for us to
        # stop processing other batch results. Eventually we will handle
        # this error to check for permission failures.

    Promise.all(batchRequests)
    .catch RpcError.SyncError, (err) =>
      Controller.syncError(err)
      @stopPolling()
    .catch Batcher.BatchFailure, (->)
      # When the batch call fails, this is going to be emitted
      # for each inner request and we'll be catching the first
      # one. But we don't care about this -- we'll look for and
      # handle the BatchFailure on the send call instead.
    .done()

    batcher.send()
    .tap ({ jqxhr }) ->
      ClientVersion.setServerVersionFromResponse(jqxhr)
    .catch Batcher.BatchFailure, ({ message, error }) ->
      Promise.reject RpcError.BatchError(message, { error })
    .nodeify(next)
    .done()



// WEBPACK FOOTER //
// ./app/scripts/network/rpc/ajax-rpc.coffee